import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.149 2.605 7.96 8.793a.625.625 0 0 0-.163.286l-.814 3.168a.625.625 0 0 0 .761.76l3.168-.813a.625.625 0 0 0 .287-.163l6.187-6.188a2.29 2.29 0 1 0-3.239-3.238Zm-5.691 8.93.508-1.98 6.066-6.066a1.04 1.04 0 1 1 1.471 1.47l-6.066 6.067-1.98.508Z",
  fill: "currentcolor"
}, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.75 4.375H10v-1.25H3.75c-.69 0-1.25.56-1.25 1.25v11.25c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-6.25h-1.25v6.25H3.75V4.375Z",
  fill: "currentcolor"
}, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }